import React, { useState, useEffect } from "react";
import ConfigTabs from "client_config/ConfigTabs";
import LeftIndent from "utils/LeftIndent";
import { Tab, Nav, Container, Form, Row, Col } from "react-bootstrap";
import Search from "./search/Search";
import Social from "./social/Social";
import Display from "./display/Display";
import Video from "./video/Video";
import All from "./all/All";
import SaveChanges from "client_config/SaveChanges";
import updateParams from "utils/updateParams.js";
import jsDig from "utils/jsDig";
import dismissDataPullErrors from "utils/dismissDataPullErrors";
import { capitalize, uniq } from "lodash-es";

export default function PPCConfig(props) {
  const [tabLocation, setTabLocation] = useState("");
  const formSubmitUrl = "/datapulse/ppc-config";
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const ppcPulling =
    jsDig(["data_pull_status", "shopify_data_pull"], props.ppc_section) && jsDig(["data_pull_status", "shopify_data_pull"], props.ppc_section).length > 0;
  const searchPulling =
    (jsDig(["data_pull_status", "google_data_pull"], props.search_section) &&
      jsDig(["data_pull_status", "google_data_pull"], props.search_section).length > 0) ||
    (jsDig(["data_pull_status", "bing_data_pull"], props.search_section) && jsDig(["data_pull_status", "bing_data_pull"], props.search_section).length > 0);
  const socialPulling =
    jsDig(["data_pull_status", "facebook_data_pull"], props.social_section) &&
    jsDig(["data_pull_status", "facebook_data_pull"], props.social_section).length > 0;
  const displayPulling =
    jsDig(["data_pull_status", "google_data_pull"], props.display_section) && jsDig(["data_pull_status", "google_data_pull"], props.display_section).length > 0;
  const videoPulling =
    jsDig(["data_pull_status", "google_data_pull"], props.video_section) && jsDig(["data_pull_status", "google_data_pull"], props.video_section).length > 0;

  const ppcRecalculating =
    jsDig(["data_pull_status", "recalculation"], props.ppc_section) &&
    jsDig(["data_pull_status", "recalculation"], props.ppc_section).length > 0;
  const searchRecalculating =
    (jsDig(["data_pull_status", "recalculation"], props.search_section) &&
      jsDig(["data_pull_status", "recalculation"], props.search_section).length > 0);

  const socialRecalculating =
    jsDig(["data_pull_status", "recalculation"], props.social_section) &&
    jsDig(["data_pull_status", "recalculation"], props.social_section).length > 0;
  const displayRecalculating =
    jsDig(["data_pull_status", "recalculation"], props.display_section) &&
    jsDig(["data_pull_status", "recalculation"], props.display_section).length > 0;
  const videoRecalculating =
    jsDig(["data_pull_status", "recalculation"], props.video_section) &&
    jsDig(["data_pull_status", "recalculation"], props.video_section).length > 0;

  const [showPpcErrors, setShowPpcErrors] = useState((jsDig(["data_pull_errors"], props.ppc_section) && Object.keys(jsDig(["data_pull_errors"], props.ppc_section)).length > 0) ? true : false)
  const [showSearchErrors, setShowSearchErrors] = useState((jsDig(["data_pull_errors"], props.search_section) && Object.keys(jsDig(["data_pull_errors"], props.search_section)).length > 0) ? true : false)
  const [showSocialErrors, setShowSocialErrors] = useState((jsDig(["data_pull_errors"], props.social_section) && Object.keys(jsDig(["data_pull_errors"], props.social_section)).length > 0) ? true : false)
  const [showDisplayErrors, setShowDisplayErrors] = useState((jsDig(["data_pull_errors"], props.display_section) && Object.keys(jsDig(["data_pull_errors"], props.display_section)).length > 0) ? true : false)
  const [showVideoErrors, setShowVideoErrors] = useState((jsDig(["data_pull_errors"], props.video_section) && Object.keys(jsDig(["data_pull_errors"], props.video_section)).length > 0) ? true : false)


  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "search";
    }
    setTabLocation(page);
    updateParams("page", page);
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
    updateParams("page", key);
  };


  const pullInProgress = () => {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>A data pull is in progress.</span>
          </div>
          <div className="description">
            <p>This page is not available while the data pull is in progress.</p>
            <span></span> Please check back later or
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  };

  const recalcInProgress = () => {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>Data is being recalculated.</span>
          </div>
          <div className="description">
            <p>Your data pull has completed but data is recalculating</p>
            <span>Please be patient {props.current_user ? props.current_user.first_name : "my guy"} and check back later or</span>
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  };

  const displayErrors = (section) => {
    return (
      <div className="spin-shell">
        <div className="spin-container" style={{ height: "auto" }}>
          <div className="title text-danger">
            <span>There were errors on the last data pull</span>
          </div>
          <div className="description">
            {jsDig([section, "data_pull_errors"], props) && Object.keys(jsDig([section, "data_pull_errors"], props)).map((platform) => {
              const errorCounts = jsDig([section, "data_pull_errors", platform], props).reduce((map, val) => { map[val] = (map[val] || 0) + 1; return map }, {});
              return (
                <React.Fragment key={platform}>
                  <div style={{ paddingTop: "30px" }}>
                    <h3 className="text-danger" style={{ textAlign: "left" }}>{capitalize(platform)}:</h3>
                    <ul style={{ listStyle: "none", textAlign: "left", paddingLeft: "10px" }}>
                      {uniq(jsDig([section, "data_pull_errors", platform], props)).map((errorMessage, index) => {
                        const length = errorCounts[errorMessage];
                        return (
                          <li key={index} style={{ wordBreak: "break-word" }}>- {length > 1 ? `(${length}x) ` : ' '}{errorMessage}</li>
                        )
                      })}
                    </ul>
                  </div>
                </React.Fragment>
              )
            })}
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-info mx-2"
                onClick={(e) => {
                  e.preventDefault()
                  dismissDataPullErrors(jsDig([section, "id"], props), section.split("_")[0])
                  $(e.target).closest('.spin-container').fadeOut();
                  setTimeout(() => {
                    location.reload()
                  }, 1000)
                }}>
                Dismiss
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <ConfigTabs enabledServices={props.enabled_services} selectedTab="ppc" />
      <Row className="styled-indent-blue">
        <Col className="pl-0 pl-md-3">
          <Form id="ppc-config-form" className="client-config-content" method="post" encType="multipart/form-data" action={formSubmitUrl}>
            <Container fluid style={{ backgroundColor: "#E1E1E1" }}>
              <SaveChanges userIsAdmin={props.user_is_admin} tabLocation={tabLocation} />
              <input hidden name="selected_page" value={tabLocation} readOnly />
              <input hidden name="client_account_id" value={props.client_account.id} readOnly />
              <input hidden name="authenticity_token" value={authenticityToken} readOnly />
              <Tab.Container id="account-config-tabs" defaultActiveKey="ppc" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
                <Nav variant="pills" className="pt-0 px-5 pb-0 nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-5">
                  <Nav.Item className="col">
                    <Nav.Link
                      eventKey="search"
                      data-link-type="page"
                      className={`${props.enabled_services.search == false ? "disabled" : ""}`}
                      style={{ opacity: props.enabled_services.search == false ? "0.5" : "" }}>
                      Search
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="col">
                    <Nav.Link
                      eventKey="social"
                      data-link-type="page"
                      className={`${props.enabled_services.social == false ? "disabled" : ""}`}
                      style={{ opacity: props.enabled_services.social == false ? "0.5" : "" }}>
                      Social
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="col">
                    <Nav.Link
                      eventKey="display"
                      data-link-type="page"
                      className={`${props.enabled_services.display == false ? "disabled" : ""}`}
                      style={{ opacity: props.enabled_services.display == false ? "0.5" : "" }}>
                      Display
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="col">
                    <Nav.Link
                      eventKey="video"
                      data-link-type="page"
                      className={`${props.enabled_services.video == false ? "disabled" : ""}`}
                      style={{ opacity: props.enabled_services.video == false ? "0.5" : "" }}>
                      Video
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="col">
                    <Nav.Link
                      eventKey="ppc"
                      data-link-type="page"
                      className={`${props.enabled_services.ppc == false ? "disabled" : ""}`}
                      style={{ opacity: props.enabled_services.ppc == false ? "0.5" : "" }}>
                      All PPC
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="ppc">
                    {ppcPulling === true && ppcRecalculating !== true ? (
                      <>
                        {pullInProgress()}
                        <div style={{ display: "none" }}>
                          <All {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : ppcRecalculating === true ? (
                      <>
                        {recalcInProgress()}
                        <div style={{ display: "none" }}>
                          <All {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : showPpcErrors ? (
                      <>
                        {displayErrors("ppc_section")}
                        <div style={{ display: "none" }}>
                          <All {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : (
                      <All {...props} selectedPage={tabLocation} />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="search">
                    {searchPulling === true ? (
                      <>
                        {pullInProgress()}
                        <div style={{ display: "none" }}>
                          <Search {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : searchRecalculating === true ? (
                      <>
                        {recalcInProgress()}
                        <div style={{ display: "none" }}>
                          <Search {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : showSearchErrors ? (
                      <>
                        {displayErrors("search_section")}
                        <div style={{ display: "none" }}>
                          <Search {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : (
                      <Search {...props} selectedPage={tabLocation} />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="social">
                    {socialPulling === true ? (
                      <>
                        {pullInProgress()}
                        <div style={{ display: "none" }}>
                          <Social {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : socialRecalculating === true ? (
                      <>
                        {recalcInProgress()}
                        <div style={{ display: "none" }}>
                          <Social {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : showSocialErrors ? (
                      <>
                        {displayErrors("social_section")}
                        <div style={{ display: "none" }}>
                          <Social {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : (
                      <Social {...props} selectedPage={tabLocation} />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="display">
                    {displayPulling === true ? (
                      <>
                        {pullInProgress()}
                        <div style={{ display: "none" }}>
                          <Display {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : displayRecalculating === true ? (
                      <>
                        {recalcInProgress()}
                        <div style={{ display: "none" }}>
                          <Display {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : showDisplayErrors ? (
                      <>
                        {displayErrors("display_section")}
                        <div style={{ display: "none" }}>
                          <Display {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : (
                      <Display {...props} selectedPage={tabLocation} />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="video">
                    {videoPulling === true ? (
                      <>
                        {pullInProgress()}
                        <div style={{ display: "none" }}>
                          <Video {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : videoRecalculating === true ? (
                      <>
                        {recalcInProgress()}
                        <div style={{ display: "none" }}>
                          <Video {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : showVideoErrors ? (
                      <>
                        {displayErrors("video_section")}
                        <div style={{ display: "none" }}>
                          <Video {...props} selectedPage={tabLocation} />
                        </div>
                      </>
                    ) : (
                      <Video {...props} selectedPage={tabLocation} />
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Container>
          </Form>
        </Col>
      </Row>
    </>
  );
}
